<template>
    <div class="split-print-rendered-content">
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <div v-if="!loading&&showSummary&&(showCostSummary||showDurationSummary)">
            <v-layout row wrap>
                <v-flex v-if="showCostSummary" xs12 :class="!reportMode&&showDurationSummary ? 'md6' : ''" >
                    <vue-plotly v-if="topCost" :white-mode="whiteMode" :data="topCost.data"
                                :layout="topCost.layout" :options="{}"/>
                </v-flex>
                <v-flex v-if="showDurationSummary" xs12 :class="!reportMode&&showCostSummary ? 'md6' : ''">
                    <vue-plotly v-if="topDuration" :white-mode="whiteMode" :data="topDuration.data"
                                :layout="topDuration.layout" :options="{}"/>
                </v-flex>
            </v-layout>
        </div>
        <div v-if="!loading&&showFaults&&showFaultsTitle">
            <v-card-title class="accent white--text subheading">
                {{ 'FDD Faults'|translate }}
            </v-card-title>
        </div>
        <div v-if="!loading&&showFaults" v-for="fault in topAHUDetails" v-bind:key="fault.rule_id"  class="pa-3">
            <v-divider></v-divider>
            <h3>{{ fault.title }}</h3>
            <v-divider class="mb-4"></v-divider>
            <p><strong>{{ 'Equipments'|translate }} : </strong>{{ fault.equipmentNames.join(', ') }}</p>
            <p><strong>{{ 'Description'|translate }} : </strong>{{ fault.desc }}</p>
            <p v-if="fault.recommended_actions"><strong>{{ 'Recommended actions'|translate }} : </strong></p>
            <ul v-if="fault.recommended_actions">
                <li v-for="i in fault.recommended_actions.split('\n')">{{ i }}</li>
            </ul>
            <fault-comparison-plot :equipment-names="fault.equipmentNames"
                                   :issue="fault.title"
                                   :fault-desc="fault.desc"
                                   :white-mode="whiteMode"
                                   :relevant-variables="fault.relevant_variables"
                                   :color="severityColors[fault.severity]"
                                   :date-range="dateRange"
            ></fault-comparison-plot>
        </div>
        <div v-if="!loading&&showAnomaly">
            <v-card-title class="accent white--text subheading">
                {{ 'Machine Learning Faults'|translate }}
            </v-card-title>
        </div>
        <div v-if="!loading&&showAnomaly" v-for="fault in topAHuAnomalyDetail" v-bind:key="fault.notification_id"  class="pa-3">
            <v-divider></v-divider>
            <h3>{{ fault.title }}</h3>
            <v-divider class="mb-4"></v-divider>
            <p><strong>Equipments : </strong>{{ fault.equipmentNames.join(', ') }}</p>
            <p><strong>Description : </strong>{{ fault.description }}</p>
            <p v-if="fault.recommended_actions"><strong>Recommended actions : </strong></p>
            <ul v-if="fault.recommended_actions">
                <li v-for="i in fault.recommended_actions.split('\n')">{{ i }}</li>
            </ul>
            <anomaly-summary-base v-for="equip in fault.equipmentNames" :range="dateRange" :white-mode="whiteMode"
                                  :equipment="equip"></anomaly-summary-base>
        </div>
    </div>
</template>

<script>

import moment from 'moment'
import {getRule, getNotification, getIssueSummary} from '@/helper'
import FaultComparisonPlot from "../FaultComparisonPlot";
import AnomalySummaryBase from "../anomaly/AnomalySummaryBase";
import printer from "../mixins/printer";
import VuePlotly from "../VuePlotly";
import LoadingProgressBar from "../LoadingProgressBar";

export default {
    name: 'FaultsReportWidget',
    props: {
        dateRange: {type: Object, default: null},
        whiteMode: {type: Boolean, default: false},
        showSummary: {type: Boolean, default: true},
        showCostSummary: {type: Boolean, default: true},
        showDurationSummary: {type: Boolean, default: true},
        showFaults: {type: Boolean, default: true},
        showFaultsTitle: {type: Boolean, default: true},
        showAnomaly: {type: Boolean, default: false},
        showAcknowledged: {type: Boolean, default: false},
        reportMode: {type: Boolean, default: false},
        severityFilter: {type: [Array, String], default: function (){return ['critical','high','medium']}},
        topicFilter: {type: [Array, String], default: ''},
    },
    watch: {
        dateRange() {
            this.handleDateChange()
        },
    },
    components: {FaultComparisonPlot, AnomalySummaryBase, VuePlotly,LoadingProgressBar},
    mixins: [printer],
    computed: {
        facility_name() {
            return this.$store.state.pointsListStore.pointsList.facility_name
        },
    },
    data() {
        return {
            menu: false,
            loading: false,
            severityColors: {
                critical: 'rgb(148, 103, 189)',
                low: 'rgb(188, 189, 34)',
                medium: 'rgb(255, 127, 14)',
                high: 'rgb(214, 39, 40)',
            },
            chillers: [],
            pumps: [],
            ahus: [],
            topPumpDetails: [],
            topAHUDetails: [],
            topAHuAnomalyDetail: [],
            topCost: null,
            topDuration: null,
            topPumpAnomalyDetail: [],
            faults: [],
            rules: [],
            comment1: "Analysis",
            topAHU: null,
            topAHUAnomaly: null,
            topPumpAnomaly: null,
            topPump: null,
            timeout:null,
        }
    },

    methods: {
        printReport() {
            this.printPage()
        },
        jumpToNotification(data, facet) {
            let output = {
                path: '/notification-breakdown',
                query: {
                    rangeStart: this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    rangeEnd: this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                }
            }
            output.query[facet] = data.points[0].label
            this.$router.push(output)
        },
        jumpToLink(item) {
            let output = null;
            if (item.title.substring(0, 7) === "Anomaly") {
                output = {
                    path: '/modelsummary',
                    query: {
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipment: item.equipment_name
                    }
                }
            } else if (item.topic === "equipment health") {
                output = {
                    path: '/equipment-health',
                    query: {
                        equipment: item.equip,
                    }
                }
            } else {
                output = {
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: item.to.query.variableX,
                        faultName: item.title,
                        faultDesc: item.description,
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipmentName: item.equipment_name
                    }
                }
            }

            this.$router.push(output)
        },
        addArrays(ar1, ar2) {
            let ar3 = [];
            for (let i in ar1)
                if (!ar2[i]) {
                    ar3.push(ar1[i]);
                } else {
                    ar3.push(ar1[i] + ar2[i]);
                }
            return ar3;
        },
        handleDateChange() {
            this.getData()
        },
        getFaultDetails(title) {
            let myRule = null
            for (let rule of this.rules) {
                if (rule.title === title) {
                    myRule = {...rule}
                    break
                }
            }
            if (myRule) {
                let equips = []
                for (let fault of this.faults) {
                    if (fault.title === title) {
                        equips.push(fault.equipment_name)
                    }
                }
                myRule.equipmentNames = [...new Set(equips)]
            }
            if (myRule) {
                return myRule
            }
            let matchingFaults = this.faults.filter(fault => fault.title === title)
            if (matchingFaults.length === 0) {
                return null
            }
            let firstFault = matchingFaults[0]
            return {
                rule_id: firstFault.notification_id || title,
                title: firstFault.title,
                desc: firstFault.description,
                recommended_actions: firstFault.recommended_actions,
                relevant_variables: firstFault.to && firstFault.to.query ? firstFault.to.query.variableX : '',
                severity: firstFault.severity ? firstFault.severity.toLowerCase() : 'high',
                equipmentNames: [...new Set(matchingFaults.map(fault => fault.equipment_name))]
            }
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        normalizeFilter(value) {
            if (!value) {
                return []
            }
            let values = Array.isArray(value) ? value : String(value).split(',')
            return values.map(x => String(x).trim().toLowerCase()).filter(x => x !== '')
        },
        notificationMatchesFilters(notification) {
            let severityFilter = this.normalizeFilter(this.severityFilter)
            let topicFilter = this.normalizeFilter(this.topicFilter)
            let severity = notification.severity ? notification.severity.toLowerCase() : ''
            let topic = notification.topic ? notification.topic.toLowerCase() : ''
            return (severityFilter.length === 0 || severityFilter.includes(severity)) &&
                (topicFilter.length === 0 || topicFilter.includes(topic))
        },
        getData(){
            this.debounce(this.refresh,500);
        },
        refresh() {
            let me = this;
            me.loading = true
            me.chillers = []
            me.pumps = []
            me.ahus = []
            getNotification({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                ignore_acknowledged: !me.showAcknowledged,
                date_range: [me.dateRange.start,me.dateRange.end],
            }).then(function (notifResult) {
                let filteredNotifications = notifResult.result.filter(function (x) {
                    return ((me.showAcknowledged || !x.acknowledged) && me.notificationMatchesFilters(x))
                })
                let rangeFaults = filteredNotifications.filter(x => !(x.topic === "anomaly" || x.title.toLowerCase().startsWith("anomaly")))
                let rangeAnomalies = filteredNotifications.filter(x => (x.topic == "anomaly" || x.title.toLowerCase().startsWith("anomaly")))
                let cpFaultSeverity = {}
                let cpFaultTopic = {}
                for (let fault of rangeFaults) {
                    if (!cpFaultSeverity[fault.severity]) {
                        cpFaultSeverity[fault.severity] = 1
                    } else {
                        cpFaultSeverity[fault.severity] = cpFaultSeverity[fault.severity] + 1
                    }
                    if (!cpFaultTopic[fault.topic]) {
                        cpFaultTopic[fault.topic] = 1
                    } else {
                        cpFaultTopic[fault.topic] = cpFaultTopic[fault.topic] + 1
                    }
                }
                let faultEquip = {}
                for (let fault of rangeFaults) {
                    if (!faultEquip[fault.equipment_type]) {
                        faultEquip[fault.equipment_type] = 1
                    } else {
                        faultEquip[fault.equipment_type] = faultEquip[fault.equipment_type] + 1
                    }
                }
                me.faults = rangeFaults.sort((a, b) => (a.end_date < b.end_date) ? 1 : -1);
                let fddRepData = []
                let faultsByType = {
                    'Pumps': rangeFaults.filter(x => x.equipment_type == "SCP"),
                    'AHUs': rangeFaults.filter(x => x.equipment_type && x.equipment_type.toLowerCase().startsWith("ahu")),
                }
                for (let faultType in faultsByType) {
                    let part = {
                        x: [],
                        y: [],
                        name: me.$options.filters.translate(faultType),
                        type: 'bar',
                        orientation: 'h'
                    }
                    for (let severity in cpFaultSeverity) {
                        part.y.push(severity)
                        part.x.push(faultsByType[faultType].filter(x => x.severity === severity).length)
                    }
                    fddRepData.push(part)
                }

                let AHUNAFaults = rangeFaults.filter(x => x.topic !== "anomaly" && !x.title.toLowerCase().startsWith("anomaly"))
                let AHUAnomaly = rangeAnomalies
                let ahuBearer = {}
                for (let fault of AHUNAFaults) {
                    if (!ahuBearer[fault.title]) {
                        ahuBearer[fault.title] = 1
                    } else {
                        ahuBearer[fault.title] += 1
                    }
                }
                let sortedAHU = Object.keys(ahuBearer).sort(function (a, b) {
                    return ahuBearer[b] - ahuBearer[a]
                })
                let top5AHU = sortedAHU;
                let top5AHUScores = []
                let topAHUDetails = [];
                for (let top of top5AHU) {
                    top5AHUScores.push(ahuBearer[top])
                    let detail = me.getFaultDetails(top)
                    if (detail) {
                        topAHUDetails.push(detail)
                    }

                }
                me.topAHUDetails = topAHUDetails
                let bearer = {}
                for (let fault of AHUAnomaly) {
                    if (!bearer[fault.title]) {
                        bearer[fault.title] = 1
                    } else {
                        bearer[fault.title] += 1
                    }
                }
                let sorted = Object.keys(bearer).sort(function (a, b) {
                    return bearer[b] - bearer[a]
                })
                let topAHuAnomaly = sorted;
                let topAHuAnomalyScores = []
                let topAHuAnomalyDetail = [];
                for (let top of topAHuAnomaly) {
                    topAHuAnomalyScores.push(bearer[top])
                    let detail = null
                    for (let fault of rangeAnomalies) {
                        if (fault.title === top) {
                            detail = fault
                            break
                        }
                    }
                    if (detail) {
                        detail.equipmentNames = [...new Set(rangeAnomalies.filter(fault => fault.title === top).map(fault => fault.equipment_name))]
                        topAHuAnomalyDetail.push(detail)
                    }
                }
                me.topAHuAnomalyDetail = topAHuAnomalyDetail;
                me.loading = false
                me.refreshSummary(rangeFaults)
            })
        },
        refreshSummary(rangeFaults) {
            let me = this
            getIssueSummary({
                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                'date_range': me.dateRange
            }).then(function (summaryResult) {
                let filteredIssues = new Set(rangeFaults.map(x => x.title ? x.title.toLowerCase() : ''))
                let filteredSummary = summaryResult.summary.filter(x => filteredIssues.has(x.issue ? x.issue.toLowerCase() : ''))
                let totalCost = filteredSummary.reduce((sum, x) => sum + x.cost, 0)
                let mostExpensive = [...filteredSummary].sort(function (a, b) {
                    return b.cost - a.cost
                }).filter(x => x.cost > 0);
                let longest = [...filteredSummary].sort(function (a, b) {
                    return b.value - a.value
                }).filter(x => x.value > 0);

                me.topCost = {
                    "data": [{
                        type: 'bar',
                        x: mostExpensive.map(x => x.cost).reverse(),
                        y: mostExpensive.map(x => x.issue).reverse(),
                        orientation: 'h',
                    }],
                    "layout": {
                        title: me.$options.filters.translate("Most Expensive Faults. Total Cost") + " : " + totalCost.toFixed(2) + " kWh",
                        autosize: true,
                        margin: {
                            l: 550
                        },
                        xaxis: {},
                        yaxis: {},
                        height: Math.max(400, 25 * mostExpensive.length),
                    }
                }
                me.topDuration = {
                    "data": [{
                        type: 'bar',
                        x: longest.map(x => x.value * 0.1).reverse(),
                        y: longest.map(x => x.issue).reverse(),
                        orientation: 'h',
                    }],
                    "layout": {
                        title: me.$options.filters.translate("Faults With Highest Duration Of Occurrence (hr)"),
                        autosize: true,
                        margin: {
                            l: 550
                        },
                        xaxis: {},
                        yaxis: {},
                        height: Math.max(400, 25 * longest.length),
                    }
                }
            })
        }

    },
    async beforeMount() {
        let rulescall = await getRule({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.rules = rulescall.result
    },
    mounted() {
        this.getData();
    }


}
</script>
